import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { LicenseInfo } from "@mui/x-license";
import { Navigate, Outlet, Route, Routes, useLocation } from "react-router";
import { setUpAxios } from "@entrilia/shared/api/axiosHelper";
import { initAuthSettings } from "@entrilia/shared/auth/settings";
import Error from "@entrilia/shared/components/Error";
import { Licenses } from "@entrilia/shared/licensing";
import { initAppInsights } from "@entrilia/shared/logging";
import { handleRedirectUrlState } from "@entrilia/shared/utilities/handleRedirectUrlState";
import { emailNotVerifiedErrorPipe } from "./api/errorPipes";
import App from "./App";
import { redirectToSignin } from "./auth/authRedirects";
import LogoutContainer from "./auth/LogoutContainer";
import { colorSchemeTheme } from "./themes";
import { importAuthSettings } from "./variables";

LicenseInfo.setLicenseKey(Licenses.MUI_X_PREMIUM_KEY);

const redirected = handleRedirectUrlState();

if (!redirected) {
  initAppInsights({ appId: "AdminPortal" });
  initAuthSettings(importAuthSettings());
  setUpAxios(redirectToSignin, [emailNotVerifiedErrorPipe]);
}

const Entry = () => {
  const { search } = useLocation();

  if (redirected) {
    return null;
  }

  return (
    // MUI defaults to mode "system"; without this, dark-OS admins get the beta dark theme until BetaThemeGuard mounts.
    <ThemeProvider theme={colorSchemeTheme} defaultMode="light" noSsr>
      <CssBaseline enableColorScheme />
      <Routes>
        <Route path="/:client/*" element={<Outlet />}>
          <Route path="logout" element={<LogoutContainer />} />
          <Route path="*" element={<App />} />
        </Route>
        <Route path="/error" element={<Error />} />
        <Route path="" element={<Navigate to={`/entrilia${search}`} />} />
      </Routes>
    </ThemeProvider>
  );
};

export default Entry;
